import moment from 'moment'

import { ContractorType } from '../people/contractor/Contractor'

import { BaseProps, BaseState } from '../../libs/ui/BaseComponent'

import { APP_CONVENZIONE } from '../../costants'

import { DATE_FORMAT } from '../../libs/validation/dateValidation'
import { UserType } from '../../libs/user/User'


export type BasePrivacyType = {
    ivass: boolean,

    generale?: boolean,
    newsletter?: boolean,
    profilazione?: boolean,
    commerciale?: boolean,
    cessione?: boolean,
    cgu?: boolean,
    allegato3e4ter?: boolean,
}

export interface BasePrivacyProps extends BaseProps {
    basePrivacy: BasePrivacyType
    showErrors?: boolean
    isLogged?: boolean
    linkAlternativePrivacy?: boolean
}

export interface BasePrivacyStatus extends BaseState {
    ivass: boolean,

    generale: boolean | undefined,
    newsletter: boolean | undefined,
    profilazione: boolean | undefined,
    commerciale: boolean | undefined,
    cessione: boolean | undefined,
    cgu: boolean | undefined,
    allegato3e4ter: boolean | undefined,
}

export function getDefaultBasePrivacy () {
    return {
        generale: false,
        newsletter: false,
        profilazione: false,
        commerciale: false,
        cessione: false,
        cgu: false,
        ivass: false,
        allegato3e4ter: false
    }
}

export function isValidPrivacy (p: BasePrivacyType, isLogged: boolean) {
    return (isLogged)
        ?   p.ivass === true
        :   (
                p.ivass === true &&
                p.generale === true &&
                p.cgu === true
            )
}

export function getPrivacyForSubmit (
    contractor: ContractorType, 
    privacy: BasePrivacyType,
    user: UserType | undefined
) {
    let flgs = [
        {
            key: 106,
            value: privacy.ivass ? 1 : 0,
            description: 'ivass'
        }
    ]

    /*
    flgs.push ({
        key: 407,
        value: (privacy.allegato3e4ter || privacy.ivass) ? 1 : 0,
        description: 'allegato3e4ter'
    })
    */
   flgs.push ({
        key: 407,
        value: 0,
        description: 'allegato3e4ter'
    })

    if (user === undefined) {
        flgs.push ({
            key: 1,
            value: privacy.generale ? 1 : 0,
            description: 'generale'
        })
        flgs.push ({
            key: 3,
            value: privacy.profilazione ? 1 : 0,
            description: 'profilazione'
        })
        flgs.push ({
            key: 22,
            value: privacy.newsletter ? 1 : 0,
            description: 'newsletter'
        })
        flgs.push ({
            key: 102,
            value: privacy.commerciale ? 1 : 0,
            description: 'commerciale'
        })
        flgs.push ({
            key: 104,
            value: privacy.cessione ? 1 : 0,
            description: 'cessione'
        })
        flgs.push ({
            key: 105,
            value: privacy.cgu ? 1 : 0,
            description: 'cgu'
        })
    } 

    const prvc = {
        email: contractor.email,
        telefono: contractor.cellulare,
        convenzione: APP_CONVENZIONE,
        consents: {
            last_change: moment(new Date()).format(DATE_FORMAT),
            flags: flgs
        }
    }

    return prvc
}